<template>
  <router-view />
</template>

<script>
export default {
  name: 'FlashcardsIndex'
}
</script>
